<template>
  <div class="user-items">
    <div class="deposit">
      <div class="balance button primary"  @click="toPage('deposit')">
        <svg width="800px" height="800px" viewBox="0 0 32 32"> <path d="M31,7H1A1,1,0,0,0,0,8V24a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V8A1,1,0,0,0,31,7ZM25.09,23H6.91A6,6,0,0,0,2,18.09V13.91A6,6,0,0,0,6.91,9H25.09A6,6,0,0,0,30,13.91v4.18A6,6,0,0,0,25.09,23ZM30,11.86A4,4,0,0,1,27.14,9H30ZM4.86,9A4,4,0,0,1,2,11.86V9ZM2,20.14A4,4,0,0,1,4.86,23H2ZM27.14,23A4,4,0,0,1,30,20.14V23Z"/> <path d="M7.51.71a1,1,0,0,0-.76-.1,1,1,0,0,0-.61.46l-2,3.43a1,1,0,0,0,1.74,1L7.38,2.94l5.07,2.93a1,1,0,0,0,1-1.74Z"/> <path d="M24.49,31.29a1,1,0,0,0,.5.14.78.78,0,0,0,.26,0,1,1,0,0,0,.61-.46l2-3.43a1,1,0,1,0-1.74-1l-1.48,2.56-5.07-2.93a1,1,0,0,0-1,1.74Z"/> <path d="M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"/> </svg>        
        {{ user.balance }} {{ user.currency }} </div>
      <a class="button primary deposit" href="javascript:;" @click="toPage('deposit')">Para Yatır</a>
    </div>
    <div class="user dropdown">
      <div class="button primary" @click="userDropdown = !userDropdown">
        <svg x="0px" y="0px" viewBox="0 0 258.75 258.75" style="enable-background:new 0 0 258.75 258.75;" xml:space="preserve"> <g> <circle cx="129.375" cy="60" r="60"/> <path d="M129.375,150c-60.061,0-108.75,48.689-108.75,108.75h217.5C238.125,198.689,189.436,150,129.375,150z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
        <svg class="arrow" :style="userDropdown ? 'transform: rotate(180deg);' : ''" x="0px" y="0px" viewBox="0 0 491.996 491.996" style="enable-background:new 0 0 491.996 491.996;" xml:space="preserve"> <g> <g> <path d="M484.132,124.986l-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86c-7.208,0-13.964,2.792-19.036,7.86l-183.84,183.848    L62.056,108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968,2.788-19.036,7.856l-16.12,16.128    c-10.496,10.488-10.496,27.572,0,38.06l219.136,219.924c5.064,5.064,11.812,8.632,19.084,8.632h0.084    c7.212,0,13.96-3.572,19.024-8.632l218.932-219.328c5.072-5.064,7.856-12.016,7.864-19.224    C491.996,136.902,489.204,130.046,484.132,124.986z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
      </div>
      <transition name="slide-fade">
          <div class="dropdown-menu right user" v-if="userDropdown">
              <div class="top-content">
                <div class="justify-item">
                  <span>Hoşgeldiniz {{ user.username }}</span>
                </div>
                <div class="justify-item">
                  <span>Bakiyeniz: </span>
                  <b>{{ user.balance }} {{ user.currency }} </b>
                </div>
                <div class="justify-item" v-if="user.user_reserve > 0">
                  <span>Anakasa Çevrimi: </span>
                  <strong>{{ user.user_reserve }} {{ user.currency }} </strong>
                </div>
                <slot class="item" v-if="user.bonus_id > 0">
                    <slot v-for="(data, provider) in user.active_bonus.remaining">
                        <slot v-if="data.data.is_active">
                            <div class="justify-item" :key="provider">
                                <span>{{ provider | ucFirst }} </span>
                                <strong class="currency" v-show="data.data.circuit != 0">{{ data.remaining }} {{ user.currency }}</strong>
                                <strong class="currency" v-show="data.data.circuit == 0">Dahil Değil</strong>
                            </div>
                        </slot>
                        <slot v-if="!data.data.is_active">
                            <div class="justify-item" style="opacity: .6" :key="provider">
                                <span class="provider">{{ provider | ucFirst }}: </span>
                                <span class="currency">-</span>
                            </div>
                        </slot>
                    </slot>
                </slot>
              </div>
              <ul>
                <li><a href="javascript:;" @click="toPage('history')">Geçmiş Hareketlerim</a></li>
                <li><a href="javascript:;" @click="toPage('bonus')">Bonuslarım</a></li>
                <li><a href="javascript:;" @click="toPage('withdraw')">Para Çek</a></li>
                <li><a href="javascript:;" @click="toPage('info')">Bilgilerim</a></li>
                <li><a href="javascript:;" @click="toPage('security')">Güvenlik ve Doğrulama</a></li>
                <li><a href="javascript:;" @click="toPage('messages')">Mesajlarım <b style="color: var(--client-c-3); margin-left:5px">({{ ticket_count }})</b></a></li>
                <li><a href="javascript:;" @click="toPage('documents')">Belgelerim</a></li>
                <li><a href="javascript:;" @click="toPage('send')">Arkadaşına Para Gönder</a></li>
                <li><a href="javascript:;" @click="logout()">Çıkış Yap</a></li>
              </ul>
          </div>
      </transition>
    </div>
  </div>
</template>

<script>
    import SocialMedia from '../SocialMedia'
    import UserPage from '../../../views/User/index'
    export default{
      props:['pages'],
      data(){
        return{
          userDropdown : false,
          userModal : false,
        }
      },
      created(){
        this.$store.dispatch('wallet/ticketCount')
      },
      methods:{
        toPage(route){
            //this.userDropdown = false;
            //this.userModal = true;
            //this.$store.commit('setUserRouter', route);
            this.$router.push({name : 'User', params:{ section: route } })
        },
        logout(){
            this.$store.dispatch('auth/logout');
        },
      },
      computed:{
        ticket_count(){
          return this.$store.getters['wallet/getTicketCount'];
        },
        user_router(){
          return this.$store.getters.getUserRouter;
        },
        user(){
          return this.$user();
        }
      },
      components:{
        SocialMedia,
        UserPage
      },
      watch:{
        $route(to, from) {
          this.userDropdown = false;
        },
        userModal(val){
          if(val){
            document.querySelector("#app").classList.add('user');
          }else{
            document.querySelector("#app").classList.remove('user');
          }
        }
      }
    }
  
  </script>